import { render, staticRenderFns } from "./CommunityFeed.vue?vue&type=template&id=cec20bbc&scoped=true&"
import script from "./CommunityFeed.vue?vue&type=script&lang=js&"
export * from "./CommunityFeed.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFeed.vue?vue&type=style&index=0&id=cec20bbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec20bbc",
  null
  
)

export default component.exports